<template>
  <el-dialog
    title="Hisse İşlem"
    :visible.sync="Modal"
    center
    width="50%">
    <a @click="$emit('ModalKapat', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <div>
      {{Mesken_id}}
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['Mesken_id', 'Modal'],
  data() {
    return {}
  },
  methods: {
    SayfaYukle() {
    }
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/mesken/MeskenHisseModal.vue